import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'orderCheckbox'
})
export class OrderCheckboxPipe implements PipeTransform {
    servicesData: any = [
        { checked: false, value: 'xray', name: 'X-Ray' },
        { checked: false, value: 'us', name: 'US' },
        { checked: false, value: 'memo', name: 'Mammo' },
        { checked: false, value: 'bmd', name: 'BMD' },
        { checked: false, value: 'nuclear', name: 'Nuclear' },
        { checked: false, value: 'cardiac', name: 'Cardiac' }
    ];

    transform(value: any): any {
        let newValue = [];
        if (value) {
            let services = value.split(',');
            services.forEach(service => {
                for (let i = 0; i < this.servicesData.length; i++) {
                    if (this.servicesData[i].value == service) {
                        newValue.push(this.servicesData[i].name)
                        break;
                    }
                }
            });
        }
        return newValue.join(', ');
    }

}



// WEBPACK FOOTER //
// /codebuild/output/src2455195120/src/src/app/shared/pipes/order-checkbox.pipe.ts